import { getCmControlsChartAssociatedRisks_OpraQueries_getCmControlsChartAssociatedRisks_Risk } from '@queries/generated/risk-assessment.generated';

export enum ActionsGridParent {
    RiskLog = 1,
    RiskMonitoring = 2,
}

export enum RiskMonitoringTab {
    ManageObservations = 1,
    ManageActions = 2,
}

export interface IRefreshGridEventBusMessage {
    topic: string;
    message: boolean;
}

export const REFRESH_GRID = 'refresh';

export interface IExtendedCmControlsRisk extends getCmControlsChartAssociatedRisks_OpraQueries_getCmControlsChartAssociatedRisks_Risk {
    dataSet: string | null | undefined;
    timePeriod: string | null | undefined;
    panelStatus: string | null | undefined;
    yAxisLabel: string | null | undefined;
    ootValue: number | null | undefined;
}
